import React, { FC, PropsWithChildren } from 'react';
import styled, { css } from 'styled-components';
import { Headline } from '~/styles';

export interface SectionProps {
  headline?: string;
  description?: string;
  isCompact?: boolean;
}

const Wrapper = styled.div<{ $isCompact?: boolean }>`
  padding: 32px;
  display: grid;
  grid-gap: 32px;
  box-sizing: border-box;
  grid-template-columns: 100%;
  width: 100%;
  align-items: start;
  justify-content: start;

  &:not(:last-of-type) {
    box-shadow: 0 1px 0 ${({ theme }) => theme.secondary.blendToBackground(200)};
  }

  ${({ $isCompact }) =>
    $isCompact &&
    css`
      padding: 0;
      grid-gap: 0;

      &:not(:last-of-type) {
        box-shadow: none;
      }
    `}
`;

const Header = styled.div`
  display: grid;
  align-items: start;
  justify-content: start;
  grid-template-columns: 25% auto;
`;

const Info = styled.div`
  display: grid;
  grid-gap: 8px;
  justify-content: start;
`;

const Description = styled.div`
  color: ${({ theme }) => theme.secondary.blendToBackground(800)};
  font-size: 12px;
  line-height: 18px;
  font-weight: 500;
`;

const Content = styled.div<{ $isCompact?: boolean }>`
  display: grid;
  grid-gap: ${({ $isCompact }) => ($isCompact ? '4px' : '24px')};
`;

export const Section: FC<PropsWithChildren<SectionProps>> = ({ headline, description, isCompact, children }) => {
  return (
    <Wrapper $isCompact={isCompact}>
      {headline && (
        <Header>
          <Info>
            <Headline size="middle">{headline}</Headline>
            {description && description.length > 0 && <Description>{description}</Description>}
          </Info>
        </Header>
      )}
      <Content $isCompact={isCompact}>{children}</Content>
    </Wrapper>
  );
};
